import React from 'react';

import { Switch, Route } from 'react-router-dom';

import Principal from './principal.js'
import Proveedores from '../proveedores'
import Impuestos from '../impuestos'
import Lineas from '../lineas'
import Marcas from '../marcas'
import Estilos from '../estilos'
import ColoresSabores from '../coloressabores'
import Medidas from '../medidas'
import Embarques from '../embarques'
import Lab from '../lab'
import Descuentos from '../descuentos'
import TiposMovimientos from '../tiposmovimientos'
import TiposConceptos from '../tiposconceptos'
import Almacenes from '../almacenes'
import TerminosPago from '../terminospagos'
import FoliosDocumentos from '../folios'
import TiposCambio from '../tiposcambio'
import MovimientosAlmacenes from '../movimientosAlmacenes'
import MovimientosCompras from '../movimientoscompras'
import MovimientosCAProveedores from '../movimientoscaproveedores'
import InventarioFisico from '../inventarioFisico'
import MovimientosCAClientes from '../movimientoscaclientes'
import InvoiceModule from './invoiceModule'

export default (props) => {
    return(
        <Switch>
             <Route exact path='/' component={Principal} />
			<Route exact path='/facturacion' component={Principal} />
			<Route exact path='/facturacion/proveedores' component={Proveedores} />
			<Route exact path='/facturacion/impuestos' component={Impuestos} />
			<Route exact path='/facturacion/lineas' component={Lineas} />
			<Route exact path='/facturacion/marcas' component={Marcas} />
			<Route exact path='/facturacion/estilos' component={Estilos} />
			<Route exact path='/facturacion/coloressabores' component={ColoresSabores} />
			<Route exact path='/facturacion/medidas' component={Medidas} />
			<Route exact path='/facturacion/embarques' component={Embarques} />
			<Route exact path='/facturacion/lab' component={Lab} />
			<Route exact path='/facturacion/descuentos' component={Descuentos} />
			<Route exact path='/facturacion/tipos_movimientos' component={TiposMovimientos} />
			<Route exact path='/facturacion/tipos_conceptos' component={TiposConceptos} />
			<Route exact path='/facturacion/almacenes' component={Almacenes} />
			<Route exact path='/facturacion/terminos_pago' component={TerminosPago} />
			<Route exact path='/facturacion/folios' component={FoliosDocumentos} />
			<Route exact path='/facturacion/tipos_cambio' component={TiposCambio} />
			<Route exact path='/facturacion/movimientosAlmacenes' component={MovimientosAlmacenes} />
			<Route exact path='/facturacion/movimientoscompras' component={MovimientosCompras} />
			<Route exact path='/facturacion/C-A/Proveedores' component={MovimientosCAProveedores} />
			<Route exact path='/facturacion/inventarioFisico' component={InventarioFisico} />
			<Route exact path='/invoiceModule' component={InvoiceModule} />
			<Route exact path='/facturacion/C-A/Clientes' component={MovimientosCAClientes} />
        </Switch>
    )
}


// WEBPACK FOOTER //
// ./src/views/facturacion/index.js